'use client';

import Script from 'next/script';
import useCookieConsent from '@/app/common/hooks/useCookieConsent';

export default function AmplitudeExperimentScriptClient({
  apiKey,
  enabled,
  isLocal,
}: {
  apiKey: string | undefined;
  enabled: boolean | undefined;
  isLocal: boolean | undefined;
}) {
  const hasConsent = useCookieConsent(isLocal);

  if (!apiKey || !enabled || !hasConsent) {
    return null;
  }

  return <Script src={`https://cdn.eu.amplitude.com/script/${apiKey}.experiment.js`} strategy="afterInteractive" />;
}
